import styled, { css } from 'styled-components';

const DrawerWrapper = styled.div(({ zIndex = 99999, theme: { olist: { components: { drawer }, }, }, }) => css `
    position: fixed;
    top: 0;
    right: 0;
    transition: opacity ease-in-out;
    opacity: 0;
    background-color: ${drawer.componentWrapper['background-color']};
    z-index: ${zIndex};
  `);
const DrawerContainer = styled.div(({ theme: { olist: { components: { drawer }, }, }, }) => css `
    display: flex;
    flex-direction: column;
    transition: width ease-in-out;
    width: 0;
    height: 100%;
    background-color: white;
    overflow: hidden;
    margin-left: auto;

    position: relative;
    border-top-left-radius: ${drawer.container['border-radius']};
    border-bottom-left-radius: ${drawer.container['border-radius']};
  `);
const DrawerCloseWrapper = styled.span(({ theme: { olist: { components: { drawer }, }, }, }) => css `
    position: absolute;
    top: ${drawer.closeWrapper.top};
    right: ${drawer.closeWrapper.right};
  `);
const DrawerHeaderContainer = styled.div(({ theme: { olist: { components: { drawer }, }, }, }) => css `
    padding-top: ${drawer.header['padding-top']};
    padding-right: ${drawer.header['padding-right']};
    padding-bottom: ${drawer.header['padding-bottom']};
    padding-left: ${drawer.header['padding-left']};
  `);
const DrawerBodyContainer = styled.div(({ theme: { olist: { components: { drawer }, }, }, }) => css `
    padding-top: ${drawer.body['padding-top']};
    padding-right: ${drawer.body['padding-right']};
    padding-bottom: ${drawer.body['padding-bottom']};
    padding-left: ${drawer.body['padding-left']};
  `);

export { DrawerBodyContainer, DrawerCloseWrapper, DrawerContainer, DrawerHeaderContainer, DrawerWrapper };
